<template>
  <div class="page-address">
    <div class="address-title">
      <span>{{ $t('smartElectricity.city.934021-0') }}</span>
    </div>
    <div class="address-not">
      <div class="address-not-msg">
        <span>{{ $t('smartElectricity.city.934021-1') }}</span>
      </div>
      <div class="address-not-button">
        <Button type="primary" @click="addModal = true">{{ $t('smartElectricity.city.934021-2') }}</Button>

        <Modal v-model="addModal" width="600" :mask-closable="false">

          <p slot="header" style="color:#f60;text-align:center">
            <span>{{ $t('smartElectricity.city.934021-3') }}</span>
          </p>

          <div style="margin-left: 30px;font-size: 14px;">
            <span style="color:#CCD0D7">{{ $t('smartElectricity.city.934021-4') }}</span><span style="font-weight: bold;margin-left: 20px;">{{ $t('smartElectricity.city.934021-5') }}</span>
          </div>
          <div style="margin-top: 20px;">
            <!-- <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80"> -->
            <Form :model="formValidate" :label-width="90">

              <FormItem :label="$t('smartElectricity.city.934021-6')">
                <Select v-model="formValidate.province" :placeholder="$t('smartElectricity.city.934021-7')" @on-change="changeProvince">
                  <Option v-for="(item) in provinceArr" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="$t('smartElectricity.city.934021-8')">
                <Select v-model="formValidate.city" :placeholder="$t('smartElectricity.city.934021-9')" @on-change="changeCity">
                  <Option v-for="(item) in citiesArr" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <FormItem :label="$t('smartElectricity.city.934021-10')">
                <Select v-model="formValidate.county" :placeholder="$t('smartElectricity.city.934021-11')">
                  <Option v-for="(item) in countyArr" :key="item.id" :value="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>

              <FormItem>
                <Button type="primary" @click="handleSubmit()">{{ $t('smartElectricity.city.934021-12') }}</Button>
              </FormItem>
            </Form>
          </div>
          <!-- 对话框页脚 删除按钮 -->
          <div slot="footer">
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {

      return {
        isMultiple: false,
        addModal: false,
        provinceArr: [],
        citiesArr: [],
        countyArr: [],
        formValidate: {
          province: '',
          city: '',
          county: ''
        }
      }
    },
    created() {
      this.$axios.get('../../../static/provinces.json').then((data) => {
        this.provinceArr = data.data;
      })
    },
    methods: {
      changeProvince(val) {
        this.provinceArr.forEach(item => {
          if (val == item.id) {
            this.citiesArr = item.child
            this.formValidate.county = ''
            this.countyArr = []
          }
        })
      },
      changeCity(val) {
        this.citiesArr.forEach(item => {
          if (val == item.id) {
            this.countyArr = item.child
          }
        })
      },

      handleSubmit() {
        let _this = this;
        let formValidate = { ..._this.formValidate
        };
        _this.provinceArr.forEach(item => {
          if (item.id == formValidate.province) {
            formValidate.provinceName = item.name;
            item.child.forEach(city => {
              if (city.id == formValidate.city) {
                formValidate.cityName = city.name;
                city.child.forEach(county => {
                  if (county.id == formValidate.county) {
                    formValidate.countyName = county.name;
                  }
                })
              }
            })
          }
        })
        console.log(formValidate)
      },
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/smartElectricity/city.vue